import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const nav = useNavigate();
  return (
    <Center mih="60vh">
      <Stack align="center" gap="md" className="app-fade-in">
        <Title order={2} c="var(--color-text)">
          404
        </Title>
        <Text c="dimmed">Diese Seite gibt es nicht.</Text>
        <Button onClick={() => nav('/')}>Zurueck</Button>
      </Stack>
    </Center>
  );
}

